module.exports = __webpack_public_path__ + "img/cornershop.141fdf23.png";